export const API_URL = "https://api.gadget.kz";
export const COLORS = ["Белый", "Черный", "Красный"];
